import { Button } from '#app/components/Buttons/Button.js';
import { ErrorBoundary } from '#app/components/ErrorBoundary/ErrorBoundary.js';
import { Text } from '#app/components/Primitives/Text.js';
import { type PropertyModalName } from '#app/types/analytics/propertyLibrary.js';
import { useModalContext } from '../hooks/useModalContext.js';
import { AdditionalDetails } from './Modal.styles.js';
import { ModalBody } from './ModalBody.js';
import { ModalHeader } from './ModalHeader.js';
import { ModalTitle } from './ModalTitle.js';
import { type ReactNode } from 'react';
import { styled } from 'styled-components';

type ModalErrorBoundaryProps = {
  readonly children: ReactNode;
  readonly modalName?: PropertyModalName;
};
const CloseContainer = styled.div`
  margin-top: 16px;
`;

export const ModalErrorBoundary = ({
  children,
  modalName,
}: ModalErrorBoundaryProps) => {
  const { onClose } = useModalContext();

  return (
    <ErrorBoundary
      boundaryIdentifier={`modal-v2-${modalName || 'generic'}`}
      renderError={({ report }) => (
        <>
          <ModalHeader>
            <ModalTitle>An unexpected error occurred.</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <Text
              as="p"
              color="uiBlackMediumEmphasis"
              mb="16px"
              textStyle="bodyRegular"
            >
              Our team has been notified about this error. If you would like to
              provide us additional details on what you were doing when the
              error occurred use the button below.
            </Text>

            <AdditionalDetails>
              <div>
                <Button onClick={report}>Provide additional details</Button>
              </div>

              <CloseContainer>
                <Button
                  onClick={onClose}
                  variant="V2Link"
                >
                  Close
                </Button>
              </CloseContainer>
            </AdditionalDetails>
          </ModalBody>
        </>
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
